(function () {
  'use strict';

  angular
  .module('navminilogin', [])

    /* @ngInject */
    .directive('navMiniLogin', function () {
      return {
        restrict: 'E',
        bindToController: {
          redirect: '@',
          titleLogin: '@',
          titleLogout: '@'
        },
        controllerAs: 'navminiLoginCtrl',
        /* @ngInject */
        controller: ["$scope", "$rootScope", "$element", "$document", "$location", "$route", "toastr", "AccountService", "LogService", "AppService", function ($scope, $rootScope, $element, $document, $location, $route, toastr, AccountService, LogService, AppService) {
          var ctrl = this;
            
          ctrl.$onInit = function () {
              LogService.redirect2 = {
                  url: ctrl.redirect
              };
              update();
          };         

          $scope.$on('userUpdate', function () {
                console.info('update');
                update(true);
          });

          $scope.$on('logUpdate', function () {
              console.info('update2');
              update(true);
          });

          $scope.$on('delogUpdate', function () {
              console.info('redirection');
          });

          // Functions

          function update(refresh) {
            refresh = refresh || false;
            AppService.getParams(refresh)
              .then(function (params) {
                ctrl.isLogged = params.IsLogged ? 1 : 0;
              })
              .catch(function (error) {
                console.error(error);
              });
          }
        }]
      };
    });

})();
